export const TYPENAME_TO_ITEM_TYPE: Record<string, 'trending' | 'promoted' | 'recommended'> = {
	FeaturedPetitionConnection: 'trending',
	PromotedPetitionConnection: 'promoted',
	RecommendedPetitionConnection: 'recommended',
};
